export const TRAINER_PAGE = '/trainer';
export const SETTINGS_PAGE = '/settings';
export const CALL_SIMULATOR_PAGE = '/call-simulator';
export const LOGIN_PAGE = '/login';
